import {browserHistory} from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/notifications';

const NotificationsService = {

  deleteNotification( id ) {
    return axios
      .delete( `${baseEndpoint}/${id}` )
  },

  deleteNotifications() {
    return axios
      .delete( 'v1/notification/all' )
  },

  getNotifications( params ) {
    return axios
      .get( baseEndpoint, { params } )
  },

  readNotifications( params ) {
    return axios
      .get( `${baseEndpoint}/read-all`, { params } )
  },

  updateNotification( id, data ) {
    return axios
      .put( `${baseEndpoint}/${id}`, data )
  },
};

export default NotificationsService;



// WEBPACK FOOTER //
// ./services/NotificationsService.js